import React, { Component, Fragment } from 'react'
import Gallery from 'react-photo-gallery'
import Lightbox from 'react-images'

export default class GalleryWithLightbox extends Component {
  constructor() {
    super()
    this.state = {
      currentImage: 0,
      lightboxIsOpen: false
    }

    this.openLightbox = this.openLightbox.bind(this);
    this.closeLightbox = this.closeLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
  }

  openLightbox(event, obj) {
    this.setState({
      currentImage: obj.index,
      lightboxIsOpen: true
    })
  }

  closeLightbox() {
    this.setState({
      currentImage: 0,
      lightboxIsOpen: false
    })
  }

  gotoPrevious() {
    this.setState({
      currentImage: this.state.currentImage - 1
    })
  }

  gotoNext() {
    this.setState({
      currentImage: this.state.currentImage + 1
    })
  }

  render() {
    return (
      <Fragment>
        <Gallery
          photos={this.props.photos}
          onClick={this.openLightbox}
          {...this.props}
        />
        <Lightbox
          images={this.props.photos}
          onClose={this.closeLightbox}
          onClickPrev={this.gotoPrevious}
          onClickNext={this.gotoNext}
          currentImage={this.state.currentImage}
          isOpen={this.state.lightboxIsOpen}
        />
      </Fragment>
    )
  }
}
